import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
const failed: string[] = ['Could not answer a phone call', 'Said "someone will reach out" instead of booking a real calendar', 'Nothing showed up in your CRM, so agents ignored it', 'Nobody read the transcripts', 'You found out it said something dumb from the lead'];
const ours: string[] = ['Answers the actual phone, live, 24/7', 'Books onto the right agent\u2019s real calendar by territory', 'Every conversation written into your CRM the same day', 'A human reads transcripts weekly and tunes it', 'Accountable in writing'];
export function BotComparison() {
  return <section id="comparison" aria-labelledby="comparison-title" className="border-b border-white/5 bg-ink-800" data-id="element-43" data-mp="2oxjdj2hdd8k8">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-44" data-mp="3md6ygb2mgu3z">
        <Reveal data-id="element-45" data-mp="3hlf6bw3tigbq">
          <h2 id="comparison-title" className="max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-46" data-mp="3hkx4mjydz9wf">
            The bot you tried vs what we run.
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-47" data-mp="128aexpwd18z6">
          <div className="rounded-xl border border-red-500/25 bg-ink-700 p-7" data-id="element-48" data-mp="127s9q3rpzkf4">
            <h3 className="font-display text-lg font-semibold tracking-tight text-white/60" data-id="element-49" data-mp="175u43kulj65w">
              The text bot you tried
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-50" data-mp="x8xtn9l509yp">
              {failed.map((item, index) => <li key={item} data-id="element-51" data-mp="x6l3481bcra1" data-mpi={index}>
                  <Reveal delay={0.06 * index} offset={10} className="flex items-start gap-3" data-id="element-52" data-mp="j9ppe2a4abnn">
                    <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full border border-red-500/40 bg-red-500/10" data-id="element-53" data-mp="2dn7i03pdpypj">
                      <XIcon className="h-3 w-3 text-red-400" aria-hidden="true" data-id="element-54" data-mp="2ikzaozxulous" />
                    </span>
                    <span className="text-sm leading-relaxed text-white/55" data-id="element-55" data-mp="2g96slqolw9e3">{item}</span>
                  </Reveal>
                </li>)}
            </ul>
          </div>

          <div className="rounded-xl border border-brand/40 bg-ink-700 p-7" data-id="element-56" data-mp="2780d9kxp14mf">
            <h3 className="font-display text-lg font-semibold tracking-tight text-brand" data-id="element-57" data-mp="228duyx30cy6r">
              What we run
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-58" data-mp="2zv35jvbs0j48">
              {ours.map((item, index) => <li key={item} data-id="element-59" data-mp="2uxumlsit0b1x" data-mpi={index}>
                  <Reveal delay={0.06 * index} offset={10} className="flex items-start gap-3" data-id="element-60" data-mp="2uymg8xsubypk">
                    <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand" data-id="element-61" data-mp="2l66zu4x6zi6s">
                      <CheckIcon className="h-3 w-3 text-ink-900" aria-hidden="true" data-id="element-62" data-mp="3io71jncgv820" />
                    </span>
                    <span className="text-sm leading-relaxed text-white/80" data-id="element-63" data-mp="3dtko7emtr5fa">{item}</span>
                  </Reveal>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}